<template>
    <div>
        <v-dialog :value="loading" :hide-overlay="true" :persistent="true" max-width="100">
            <div class="text-center loading">
                <v-progress-circular
                    :size="20"
                    color="primary"
                    indeterminate
                    width="2"
                ></v-progress-circular>
            </div>
        </v-dialog>
        <linked-content-dialog
            @close="close"
            @print="openInNewTab"
            v-for="(linkedContent, index) in linkedContents"
            :linkedContent="linkedContent"
            :active="active[linkedContent.contentId]"
            :key="linkedContent._ui"
            :index="index"
        />
    </div>
</template>

<script>
import Vue from "vue";
import { EventBus } from "src/bus/eventBus";
import { Services } from "src/services/Services";
import LinkedContentDialog from "./LinkedContentDialog.vue";
import { forEach, compact } from "lodash";

export default Vue.extend({
    components: {
        LinkedContentDialog,
    },
    data() {
        return {
            loading: false,
            linkedContents: [],
            active: {},
        };
    },
    mounted() {
        EventBus.$on("linked-content:show", async id => {
            this.loading = true;
            setTimeout(async () => {
                this.loading = false;
                const linkedContent = await Services.api.linkedContent.get(id);
                this.active[id] = true;
                this.linkedContents.push(linkedContent);
            }, 300);
        });
    },
    methods: {
        close(linkedContent) {
            delete this.active[linkedContent.contentId];
            this.active = { ...this.active };
            setTimeout(() => {
                forEach(this.linkedContents, (l, index) => {
                    if (l.contentId == linkedContent.contentId) {
                        delete this.linkedContents[index];
                    }
                });
                this.linkedContents = compact(this.linkedContents);
            }, 500);
        },
        openInNewTab(linkedContent) {
            const href = this.$router.resolve({
                name: "linked-content",
                params: { id: linkedContent.contentId },
            }).href;

            window.open(href, "_blank");
        },
    },
});
</script>

<style lang="sass" scoped>

.v-card__text
    padding: $grid-gutter*2 !important
    margin: auto

.v-card__title
    background: $color-background

.icon
    margin-left: auto
    color: $color-main

.loading
    padding: $grid-gutter
    width: 100px
    height: 100px
    display: flex
    align-items: center
    justify-content: center
    background: white
</style>
